// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
const Queue = require('promise-queue');
Queue.configure(require('bluebird'));
